import noise from '../chunks/noise.raw.xml';
import random from '../chunks/random.raw.xml';
import rotate from '../chunks/rotate.raw.xml';

export default () => ({
    noise,
    random,
    rotate,
});



// WEBPACK FOOTER //
// ./src/js/services/chunks.js